import { color, OnyxGray } from 'canoe';
import styled from 'styled-components';

export const Separator = styled.div`
  width: 1px;
  background-color: ${color(OnyxGray, 1)};
  margin: 4px 2px;
  height: 20px;
`;
